const replaceLastInstance = (value, searchValue, replaceValue) => {
    const lastIndex = value.lastIndexOf(searchValue);
    if (lastIndex >= 0) {
        return value.slice(0, lastIndex) + replaceValue + value.slice(lastIndex + 1);
    }
    return value;
};
export const adoptOrphans = (value, maxToAdopt = 1) => {
    let result = value;
    for (let numSpacesReplaced = 0; numSpacesReplaced < maxToAdopt; numSpacesReplaced += 1) {
        result = replaceLastInstance(result, ' ', '\u00a0');
    }
    return result;
};
//# sourceMappingURL=adoptOrphans.js.map